import React from "react";
import PropTypes from "prop-types";
import InlineNotification from "./InlineNotification";

const NOTIFICATION_TYPES_MAP = {
  green: 'success',
  red: 'error',
  blue: 'info',
  yellow: 'warning'
};

export default class SystemNotification extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired
  };

  onClose = () => {
    this.props.onClose(this.props.id);
  }

  getNotificationType = (type) => {
    return NOTIFICATION_TYPES_MAP[type];
  } 

  render() {
    const { title, content, level } = this.props;
    return (
      <InlineNotification type={this.getNotificationType(level)} closeAction={this.onClose}>
        <span className="notification-title">{title}</span> <span dangerouslySetInnerHTML={{ __html: content }} className="notification-body"/>
      </InlineNotification>
    );
  }
}
